/* sf-speed 2026-10-13: one shared /cart.js request for sf-ux, sf-set and sf-notify during the first 4 s of a page load (was 4 requests). Each caller gets its own parsed copy; any cart update clears the shared result. */
window.sfCart=window.sfCart||function(){if(window.__sfCartP)return window.__sfCartP.then(JSON.parse);var p=fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){return r.text()});window.__sfCartP=p;p.then(function(){window.__sfCartP=null},function(){window.__sfCartP=null});return p.then(JSON.parse)};
try{document.addEventListener('DOMContentLoaded',function(){typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&subscribe(PUB_SUB_EVENTS.cartUpdate,function(){window.__sfCartP=null})})}catch(e){}
function sfPG(d){var e=d.getElementById("product-grid");return e&&e.tagName!=="UL"&&e.querySelector("ul.product-grid")||e}
/* Sam's Fragrances UX helpers (2026-09-25): sticky mobile add-to-cart, free-delivery progress, collection "Load more". */
(function () {
  'use strict';
  var FREE = 125; // USD free-delivery threshold (Settings > Shipping)
  var money = function (n) { n = Math.round(n * 100) / 100; return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); };

  /* ---------- 1. Sticky add-to-cart bar on phones ---------- */
  function stickyATC() {
    var SEL = 'product-form button[name="add"]';
    if (!document.querySelector(SEL) || document.getElementById('sf-sticky-atc')) return;
    var title = (document.querySelector('.product__title h1, h1') || {}).textContent || '';
    var bar = document.createElement('div');
    bar.id = 'sf-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="sf-sa__info"><span class="sf-sa__title"></span><span class="sf-sa__price"></span></div><button type="button" class="sf-sa__btn"></button>';
    bar.querySelector('.sf-sa__title').textContent = title.trim();
    document.body.appendChild(bar);
    var priceEl = function () {
      var p = document.querySelector('[id^="price-template"][id$="__main"] .price-item--last, [id^="price-template"][id$="__main"] .price-item--sale, [id^="price-template"][id$="__main"] .price-item--regular');
      return p ? p.textContent.replace(/\s*USD\s*/, '').trim() : '';
    };
    var tick = false;
    var update = function () {
      tick = false;
      var btn = document.querySelector(SEL); // theme re-renders the form, so always look it up fresh
      if (!btn) return;
      bar.querySelector('.sf-sa__price').textContent = priceEl();
      var b = bar.querySelector('.sf-sa__btn');
      var dis = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      var nb = dis && !btn.classList.contains('loading') && document.querySelector('.sf-notify__btn'); // sf-notify-sticky-20261022: sold out -> Notify me
      if (nb && nb.offsetParent === null) nb = null;
      b.textContent = nb ? 'Notify me' : ((btn.querySelector('span') || btn).textContent.trim() || 'Add to cart');
      b.disabled = dis && !nb;
      b.classList.toggle('sf-sa__btn--notify', !!nb);
      var show = window.innerWidth < 750 && btn.getBoundingClientRect().bottom < 0;
      if (bar.classList.contains('is-visible') !== show) {
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('sf-sa-open', show);
      }
    };
    var req = function () { if (!tick) { tick = true; requestAnimationFrame(update); } };
    bar.querySelector('.sf-sa__btn').addEventListener('click', function () {
      if (this.classList.contains('sf-sa__btn--notify')) { var n = document.querySelector('.sf-notify__btn'); if (n) { n.scrollIntoView({ block: 'center' }); n.click(); } return; }
      var btn = document.querySelector(SEL);
      if (btn && !btn.disabled) btn.click();
    });
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    document.addEventListener('change', function () { setTimeout(update, 400); }); // variant switch
    update();
  }

  /* ---------- 2. Free-delivery progress in cart drawer + cart page ---------- */
  // The theme re-renders the footer on every quantity change, which wiped the bar until /cart.js came back.
  // Now the bar is redrawn SYNCHRONOUSLY from the last known total (no gap), can be driven instantly by
  // sf-cart-instant via window.sfFreeShip(total), and is then confirmed by /cart.js.
  var busy = false, again = false, lastPct = 0, lastTotal = null, lastCount = 0;
  var TARGETS = 'cart-drawer .drawer__footer, .cart__footer .cart__blocks, #main-cart-footer .cart__blocks';
  function render(total, count) {
    lastTotal = total; lastCount = count;
    var left = FREE - total, pct = Math.min(100, Math.round(total / FREE * 100));
    var msg = left > 0 ? 'You’re <b>' + money(left) + '</b> away from <b>free delivery</b>' : 'You’ve unlocked <b>free delivery</b>';
    document.querySelectorAll(TARGETS).forEach(function (t) {
      var el = t.querySelector('.sf-free');
      if (!count) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('div'); el.className = 'sf-free';
        el.innerHTML = '<p class="sf-free__msg"></p><div class="sf-free__bar"><span style="width:' + lastPct + '%"></span></div>';
        t.insertBefore(el, t.firstChild);
      }
      var m = el.querySelector('.sf-free__msg'), s = el.querySelector('.sf-free__bar span');
      if (m.innerHTML !== msg) m.innerHTML = msg;
      el.classList.toggle('is-done', left <= 0);
      if (s.style.width !== pct + '%') { void s.offsetWidth; s.style.width = pct + '%'; }
    });
    lastPct = count ? pct : 0;
  }
  // After an add or re-render the theme has already printed the NEW subtotal in the footer, so use that
  // rather than the last /cart.js total — otherwise the bar briefly draws the old (lower) fill, then grows.
  function shownTotal() {
    var t = (document.querySelector('#main-cart-footer .totals__total-value') || document.querySelector('cart-drawer .totals__total-value'));
    if (!t) return null;
    var v = parseFloat(String(t.textContent).replace(/,/g, '').match(/[\d.]+/) || 'x');
    return isNaN(v) ? null : v;
  }
  function restore() {
    var v = shownTotal();
    if (v !== null && v > 0) { render(v, Math.max(lastCount, 1)); return; }
    if (lastTotal !== null) render(lastTotal, lastCount);
  }
  window.sfFreeShip = function (total) { if (lastCount) render(total, lastCount); };
  // instant: sf-cart-instant rewrites the subtotal on +/- before the server answers; follow it immediately
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('.cart-item .quantity__button, cart-remove-button'))) return;
    // The instant-price script rewrites the subtotal ~60 ms after the tap, so read it a few times.
    [90, 200, 400].forEach(function (d) { setTimeout(function () {
      var t = e.target.closest('cart-drawer') ? document.querySelector('cart-drawer .totals__total-value') : (document.querySelector('#main-cart-footer .totals__total-value') || document.querySelector('.totals__total-value')); if (!t) return;
      var v = parseFloat(String(t.textContent).replace(/,/g, '').match(/[\d.]+/) || 'x');
      if (!isNaN(v)) window.sfFreeShip(v);
    }, d); });
  }, true);
  function freeShip() {
    if (busy) { again = true; return; } busy = true;
    (window.sfCart?window.sfCart():fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()})).then(function (c) {
      busy = false;
      if (again) { again = false; freeShip(); return; } // a newer change is pending — skip this older answer
      render(c.total_price / 100, c.item_count);
      if (again) { again = false; freeShip(); }
    }).catch(function () { busy = false; });
  }

  /* ---------- 3. Load more on collection pages ---------- */
  // Everything is read from the CURRENT DOM at click time, because the filter form swaps the grid and the
  // pagination links in place — cached URLs/counts go stale after a filter change.
  var nextHref = function (root) {
    var w = root.querySelector('.pagination-wrapper');
    if (!w) return null;
    var cur = w.querySelector('[aria-current="page"]');
    var a = w.querySelector('a[rel="next"], a[aria-label*="Next" i]');
    if (!a && cur) { var li = cur.closest('li'); var nx = li && li.nextElementSibling; a = nx && nx.querySelector('a'); }
    var h = a && a.getAttribute('href');
    return h && /page=\d+/.test(h) ? h : null;
  };
  // "359 of 1844 products" when filtered, "1844 products" otherwise — the first number is the one that applies
  var totalText = function () { var m = (document.querySelector('#ProductCount, #ProductCountDesktop, .product-count__text') || document.body).textContent.match(/([\d,]+)\s+(?:of\s+[\d,]+\s+)?(?:products?|results?)/); return m ? m[1] : ''; };
  function loadMore() {
    var grid = sfPG(document);
    var wrap = document.querySelector('.pagination-wrapper');
    document.querySelectorAll('.sf-lm').forEach(function (b) { if (!wrap || b.previousElementSibling !== wrap) b.remove(); });
    if (!grid || !wrap) return;
    if (!nextHref(document)) { var old = wrap.nextElementSibling; if (old && old.classList.contains('sf-lm')) old.remove(); if(!window.sfAppended)wrap.classList.remove('sf-lm-hidden'); return; }
    wrap.classList.add('sf-lm-hidden');
    var box = wrap.nextElementSibling && wrap.nextElementSibling.classList.contains('sf-lm') ? wrap.nextElementSibling : null;
    if (!box) {
      box = document.createElement('div');
      box.className = 'sf-lm';
      box.innerHTML = '<p class="sf-lm__count"></p><button type="button" class="button sf-lm__btn">Load more</button>';
      wrap.parentNode.insertBefore(box, wrap.nextSibling);
      box.querySelector('button').addEventListener('click', function () {
        var b = this, url = nextHref(document);
        if (!url) { box.remove(); return; }
        b.disabled = true; b.textContent = 'Loading…';
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
          var doc = new DOMParser().parseFromString(h, 'text/html');
          var g = sfPG(doc), liveGrid = sfPG(document);
          if (g && liveGrid) Array.prototype.forEach.call(g.children, function (li) { window.sfAppended=true;liveGrid.appendChild(document.importNode(li, true)); });
          var w = doc.querySelector('.pagination-wrapper'), lw = document.querySelector('.pagination-wrapper');
          if (w && lw) lw.innerHTML = w.innerHTML; // advance the (hidden) pagination so the next click fetches the next page
          document.dispatchEvent(new CustomEvent('sf:products-appended'));
          b.disabled = false; b.textContent = 'Load more';
          loadMore();
        }).catch(function () { b.disabled = false; b.textContent = 'Load more'; });
      });
    }
    var t = totalText();
    box.querySelector('.sf-lm__count').textContent = 'Showing ' + grid.children.length + (t ? ' of ' + t : '') + ' products';
  }

  function init() { stickyATC(); freeShip(); loadMore(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // cart updates (Dawn/Rise publish cart events; also watch the drawer re-render)
  ['cart:update', 'cart:refresh', 'ajaxProduct:added'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(freeShip, 300); }); });
  var hookDrawer = function () {
    var sfOwn = function (ms) { return ms.every(function (x) { var t = x.target, own = function (n) { return n.classList && n.classList.contains('sf-free'); }; return (t.closest && t.closest('.sf-free')) || (x.addedNodes.length + x.removedNodes.length > 0 && [].every.call(x.addedNodes, own) && [].every.call(x.removedNodes, own)); }); };
    var d = document.querySelector('cart-drawer');
    if (d) new MutationObserver(function (ms) { if (sfOwn(ms)) return; restore(); setTimeout(freeShip, 150); }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    var m = document.getElementById('main-cart-footer') || document.querySelector('.cart__footer');
    if (m) new MutationObserver(function (ms) { if (sfOwn(ms)) return; restore(); setTimeout(freeShip, 150); }).observe(m, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookDrawer); else hookDrawer();
  // re-arm Load more after the filter form swaps the grid
  var lmTimer;
  var armLM = function () {
    var col = document.getElementById('ProductGridContainer') || document.querySelector('.collection');
    if (col) new MutationObserver(function (muts) {
      // ignore our own appends to the grid; react when the theme swaps the grid/pagination
      if (muts.every(function (m) { return m.target.id === 'product-grid' || (m.target.closest && m.target.closest('.sf-lm')); })) return;
      clearTimeout(lmTimer); lmTimer = setTimeout(loadMore, 250);
    }).observe(col, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armLM); else armLM();
})();

/* sf-cart-extras 2026-10-01: coupon note + desktop 'View full cart' link */
(function(){function add(){document.querySelectorAll('.cart__ctas').forEach(function(c){if(c.parentNode.querySelector('.sf-coupon-note'))return;var p=document.createElement('p');p.className='sf-coupon-note';p.textContent='Delivered in 1 to 4 days';c.parentNode.insertBefore(p,c);});var h=document.querySelector('cart-drawer .drawer__header');if(h&&!h.querySelector('.sf-view-cart')){var a=document.createElement('a');a.href='/cart';a.className='sf-view-cart';a.textContent='View full cart';h.appendChild(a);}}function watch(){add();var t;['cart-drawer','#main-cart-footer'].forEach(function(s){var el=document.querySelector(s);if(el)new MutationObserver(function(){clearTimeout(t);t=setTimeout(add,40);}).observe(el,{childList:true,subtree:true});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();})();

/* sf-cart-savings 2026-10-02: 'You save $X' line + total on checkout button */
(function(){var cache={},busy=0;function money(c){return '$'+(c/100).toFixed(2)}function upd(){if(busy)return;busy=1;(window.sfCart?window.sfCart():fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()})).then(function(c){var need=c.items.filter(function(it){return cache[it.variant_id]===undefined});return Promise.all(need.map(function(it){return fetch('/products/'+it.handle+'.js').then(function(r){return r.json()}).then(function(p){p.variants.forEach(function(v){cache[v.id]=v.compare_at_price||0})}).catch(function(){cache[it.variant_id]=0})})).then(function(){return c})}).then(function(c){var save=0;c.items.forEach(function(it){var cp=cache[it.variant_id]||0;if(cp>it.final_price)save+=(cp-it.final_price)*it.quantity});document.querySelectorAll('.cart__ctas').forEach(function(ct){var f=ct.parentNode,s=f.querySelector('.sf-save');if(save>0&&c.item_count>0){if(!s){s=document.createElement('p');s.className='sf-save';var tot=f.querySelector('.totals');if(tot)tot.parentNode.insertBefore(s,tot.nextSibling);else f.insertBefore(s,ct)}var tx='You save '+money(save);if(s.textContent!==tx)s.textContent=tx}else if(s)s.remove()});}).catch(function(){}).finally(function(){busy=0})}function watch(){upd();var t;['cart-drawer','#main-cart-footer'].forEach(function(s){var el=document.querySelector(s);if(el)new MutationObserver(function(){clearTimeout(t);t=setTimeout(upd,120)}).observe(el,{childList:true,subtree:true})})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();})();

/* lighthouse 2026-10-08: sticky ATC is aria-hidden, keep its controls out of the tab order */
(function(){var n=0;function f(){var b=document.getElementById("sf-sticky-atc");if(b){b.querySelectorAll("a,button,input,select,textarea,[tabindex]").forEach(function(e){e.setAttribute("tabindex","-1")});}if(n++<20)setTimeout(f,500);}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",f);else f();})();

/* sf-selected-value-20261018: show the chosen option next to its label (e.g. Color: 10 Flowers) */
(function(){
  function upd(){
    document.querySelectorAll('variant-selects fieldset').forEach(function(fs){
      var lg=fs.querySelector('legend'); var c=fs.querySelector('input[type=radio]:checked');
      if(!lg||!c) return;
      var s=lg.querySelector('.sf-sel');
      if(!s){ s=document.createElement('span'); s.className='sf-sel'; s.style.fontWeight='400'; lg.appendChild(s); }
      var v=': '+c.value; if(s.textContent!==v) s.textContent=v;
    });
  }
  document.addEventListener('change',function(e){ if(e.target&&e.target.closest&&e.target.closest('variant-selects')){ [0,400,1200].forEach(function(t){ setTimeout(upd,t); }); } });
  try{ if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.variantChange){ subscribe(PUB_SUB_EVENTS.variantChange,function(){ setTimeout(upd,60); }); } }catch(e){}
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',upd); } else { upd(); }
})();

/* sf-eta-20261020: product page delivery line shows a date ("Delivery by Thursday 24 Oct") instead of
   "in 1 to 4 days". Counts 4 delivery days from tomorrow, Monday to Saturday, Beirut time.
   Keeps the original text on pre-order and sold-out pages. */
(function(){
  var D=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function eta(){
    var p;try{p=new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Beirut',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());}catch(e){return null}
    var g=function(t){for(var i=0;i<p.length;i++){if(p[i].type===t)return +p[i].value}return 0};
    if(!g('year'))return null;
    var d=new Date(Date.UTC(g('year'),g('month')-1,g('day'),12)),n=0;
    while(n<4){d.setUTCDate(d.getUTCDate()+1);if(d.getUTCDay()!==0)n++;}
    return D[d.getUTCDay()]+' '+d.getUTCDate()+' '+M[d.getUTCMonth()];
  }
  function upd(){
    var els=document.querySelectorAll('.sf-eta');if(!els.length)return;
    var pre=document.querySelector('.sf-preorder-note');
    var btn=document.querySelector('button[name="add"][id^="ProductSubmitButton"]');
    var sold=!!(btn&&btn.disabled&&/sold out/i.test(btn.textContent));
    var e=eta();
    for(var i=0;i<els.length;i++){
      var el=els[i];
      if(!el.hasAttribute('data-def'))el.setAttribute('data-def',el.textContent);
      var t=(pre||sold||!e)?el.getAttribute('data-def'):'by '+e;
      if(el.textContent!==t)el.textContent=t;
    }
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',upd):upd();
  document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('variant-selects'))[0,400,1200].forEach(function(t){setTimeout(upd,t)})});
  try{typeof subscribe=='function'&&typeof PUB_SUB_EVENTS!='undefined'&&PUB_SUB_EVENTS.variantChange&&subscribe(PUB_SUB_EVENTS.variantChange,function(){setTimeout(upd,60)})}catch(e){}
})();

/* sf-qty-guard-20261022: a typed 0 or empty quantity on the product form falls back to the minimum */
document.addEventListener('change',function(e){var i=e.target;if(i&&i.matches&&i.matches('.product-form__quantity quantity-input input')&&(!i.value||+i.value<(+i.min||1)))i.value=i.min||1;},true);


/* sf-cart-upsell-20261023: 'You may also like' (3 related in-stock items with a one-tap Add) inside the cart drawer and on the cart page. Source: Shopify product recommendations for the newest cart item. */
(function(){
  var recCache={},busy=0,t;
  function money(c){return '$'+(c/100).toFixed(2).replace(/\.00$/,'')}
  function esc(s){return String(s).replace(/[&<>"]/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]})}
  function host(){
    var p=document.querySelector('#main-cart-items cart-items, cart-items:not(cart-drawer-items)');
    if(p&&p.offsetParent!==null)return p;
    var d=document.querySelector('#CartDrawer cart-drawer-items');
    return d&&!document.querySelector('cart-drawer .drawer__inner.is-empty')?d:null;
  }
  function recs(pid){
    if(recCache[pid])return recCache[pid];
    var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    var get=function(intent){return fetch(base+'recommendations/products.json?product_id='+pid+'&limit=10&intent='+intent).then(function(r){return r.ok?r.json():{products:[]}}).then(function(j){return j.products||[]}).catch(function(){return []})};
    recCache[pid]=get('complementary').then(function(a){return a.length>=3?a:get('related').then(function(b){return a.concat(b)})});
    return recCache[pid];
  }
  function render(){
    if(busy)return;var h=host();if(!h)return;busy=1;
    (window.sfCart?window.sfCart():fetch('/cart.js').then(function(r){return r.json()})).then(function(c){
      if(!c.items.length){var o=document.querySelector('.sf-upsell');if(o)o.remove();return}
      var inCart={};c.items.forEach(function(it){inCart[it.product_id]=1});
      var pid=c.items[0].product_id;
      return recs(pid).then(function(list){
        var seen={},pick=[];
        list.forEach(function(p){if(pick.length>=3||seen[p.id]||inCart[p.id]||!p.available)return;var v=(p.variants||[]).filter(function(x){return x.available})[0];if(!v||!v.price)return;seen[p.id]=1;pick.push({p:p,v:v})});
        var key=pid+':'+pick.map(function(x){return x.v.id}).join(',');
        var h2=host();if(!h2)return;
        var old=h2.querySelector('.sf-upsell');
        if(old&&old.getAttribute('data-key')===key)return;
        if(old)old.remove();
        if(!pick.length)return;
        var el=document.createElement('div');el.className='sf-upsell'+(h2.tagName==='CART-ITEMS'?' page-width':'');el.setAttribute('data-key',key);
        el.innerHTML='<p class="sf-upsell__title">You may also like</p>'+pick.map(function(x){
          var img=x.p.featured_image?(x.p.featured_image.replace(/^https?:/,'')+(x.p.featured_image.indexOf('?')>-1?'&':'?')+'width=120'):'';
          return '<div class="sf-upsell__item"><a class="sf-upsell__img" href="'+esc(x.p.url)+'">'+(img?'<img src="'+esc(img)+'" alt="'+esc(x.p.title)+'" width="56" height="56" loading="lazy">':'')+'</a>'+
            '<a class="sf-upsell__name" href="'+esc(x.p.url)+'">'+esc(x.p.title)+'</a>'+
            '<span class="sf-upsell__price">'+money(x.v.price)+'</span>'+
            '<button type="button" class="sf-upsell__add" data-id="'+x.v.id+'" aria-label="Add '+esc(x.p.title)+' to cart">Add</button></div>'}).join('');
        h2.appendChild(el);
      });
    }).catch(function(){}).finally(function(){busy=0});
  }
  function later(){clearTimeout(t);t=setTimeout(render,150)}
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.sf-upsell__add');if(!b||b.disabled)return;
    e.preventDefault();b.disabled=true;b.textContent='Adding...';
    var drawer=document.querySelector('cart-drawer');var inDrawer=!!b.closest('cart-drawer');
    var body={items:[{id:+b.getAttribute('data-id'),quantity:1}]};
    if(inDrawer&&drawer&&drawer.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(function(s){return s.id});body.sections_url=location.pathname}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json()}).then(function(res){
      window.__sfCartP=null;
      if(res.status){b.textContent='Sold out';return}
      try{if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'sf-upsell',cartData:res})}catch(_){}
      if(inDrawer&&drawer&&res.sections){drawer.renderContents(res)}else{location.reload()}
    }).catch(function(){b.disabled=false;b.textContent='Add'});
  });
  function watch(){
    render();
    ['cart-drawer','#main-cart-items'].forEach(function(s){var el=document.querySelector(s);if(!el)return;
      new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var n=ms[i].target;if(!(n.closest&&n.closest('.sf-upsell'))&&!(ms[i].addedNodes.length===1&&(ms[i].addedNodes[0].classList&&ms[i].addedNodes[0].classList.contains('sf-upsell')))&&!(ms[i].removedNodes.length===1&&(ms[i].removedNodes[0].classList&&ms[i].removedNodes[0].classList.contains('sf-upsell')))){later();return}}}).observe(el,{childList:true,subtree:true})});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();
})();


/* sf-readmore-20261028: long collection intros fold to 3 lines on phones (text stays on the page) */
(function(){
  function init(){
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.collection-hero__description').forEach(function(d){
      if (d.dataset.sfRm) return; d.dataset.sfRm = '1';
      var p = d.querySelector('p') || d; var lh = parseFloat(getComputedStyle(p).lineHeight) || 24;
      var max = Math.round(lh * 3);
      if (d.scrollHeight <= max + lh * 1.5) return;
      d.style.setProperty('--sf-rm-h', max + 'px'); d.classList.add('sf-rm');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'sf-rm__btn';
      b.setAttribute('aria-expanded', 'false'); b.textContent = 'Read more';
      b.addEventListener('click', function(){ var o = d.classList.toggle('sf-rm--open'); b.setAttribute('aria-expanded', o ? 'true' : 'false'); b.textContent = o ? 'Show less' : 'Read more'; });
      d.insertAdjacentElement('afterend', b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* sf-sticky-checkout-20261028: phone cart page keeps the total + Check out at the bottom while the real button is off screen */
(function(){
  if (!/^\/cart\/?$/.test(location.pathname)) return;
  function init(){
    var mq = window.matchMedia('(max-width: 749px)');
    var bar = document.createElement('div');
    bar.id = 'sf-sticky-co'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="sf-co__info"><span class="sf-co__total"></span><span class="sf-co__note"></span></div><button type="button" class="sf-co__btn button" tabindex="-1">Check out</button>';
    document.body.appendChild(bar);
    var inView = true, watched = null;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){ inView = es[0].isIntersecting; update(); }) : null;
    function update(){
      var btn = document.getElementById('checkout'), t = document.querySelector('.totals__total-value');
      if (io && btn && btn !== watched){ if (watched) io.unobserve(watched); io.observe(btn); watched = btn; }
      var txt = t ? t.textContent.trim() : '', n = parseFloat(txt.replace(/[^0-9.]/g, '')) || 0;
      bar.querySelector('.sf-co__total').textContent = txt;
      bar.querySelector('.sf-co__note').textContent = n >= 125 ? 'Free delivery' : 'Free delivery over $125';
      var show = mq.matches && btn && !btn.disabled && txt && !inView;
      bar.classList.toggle('is-visible', !!show);
      document.body.classList.toggle('sf-sa-open', !!show);
    }
    bar.querySelector('button').addEventListener('click', function(){ var b = document.getElementById('checkout'); if (b) b.click(); });
    var footer = document.getElementById('main-cart-footer'), raf = 0;
    if (footer) new MutationObserver(function(){ if (raf) return; raf = requestAnimationFrame(function(){ raf = 0; update(); }); }).observe(footer, {childList: true, subtree: true, characterData: true});
    if (mq.addEventListener) mq.addEventListener('change', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* sf-design-20261103 */
(function(){
function notes(){var d=document.querySelector('.product__description');if(!d||d.querySelector('.sf-notes'))return;
var re=/^\s*(top|heart|middle|base)(?:\s+notes?)?\s*:\s*(\S.*)$/i,rows=[],nodes=[];
d.querySelectorAll('li,p').forEach(function(el){if(el.tagName==='P'&&el.closest('li'))return;if(el.querySelector('ul,ol'))return;
var ls=el.innerHTML.split(/<br\s*\/?>/i).map(function(h){var t=document.createElement('div');t.innerHTML=h;return t.textContent.trim()}).filter(Boolean);
if(!ls.length)return;var m=ls.map(function(l){return l.match(re)});if(m.every(Boolean)){m.forEach(function(x){rows.push([x[1].toLowerCase()==='middle'?'heart':x[1].toLowerCase(),x[2]])});nodes.push(el)}});
if(rows.length!==3)return;var seen=rows.map(function(r){return r[0]}).join();if(seen!=='top,heart,base')return;
for(var i=1;i<nodes.length;i++)if(nodes[i-1].nextElementSibling!==nodes[i])return;
var box=document.createElement('dl');box.className='sf-notes';
rows.forEach(function(r){var w=document.createElement('div');w.className='sf-notes__row';var a=document.createElement('dt');a.className='sf-notes__label';a.textContent=r[0].charAt(0).toUpperCase()+r[0].slice(1);var b=document.createElement('dd');b.textContent=r[1];w.appendChild(a);w.appendChild(b);box.appendChild(w)});
var first=nodes[0],host=first.closest('ul,ol')||first;var prev=host.previousElementSibling;if(prev&&/^fragrance notes:?$/i.test(prev.textContent.trim()))prev.remove();
host.parentNode.insertBefore(box,host);nodes.forEach(function(n){var p=n.closest('ul,ol');n.remove();if(p&&!p.children.length)p.remove()});}
function lift(){if(!document.querySelector('.product__info-container product-form'))return;var tick=false;
function run(){tick=false;var box=document.querySelector('.product__info-container');if(!box)return;
var g=[].slice.call(box.querySelectorAll('.product-form__quantity,.product-form__buttons,.shopify-payment-button')).map(function(e){return e.getBoundingClientRect()}).filter(function(r){return r.height>0});if(!g.length)return;
var t=Math.min.apply(null,g.map(function(r){return r.top})),b=Math.max.apply(null,g.map(function(r){return r.bottom})),l=Math.min.apply(null,g.map(function(r){return r.left})),r=Math.max.apply(null,g.map(function(x){return x.right}));
var todo=[];document.querySelectorAll('.whatsapp-icon,#back-to-top').forEach(function(el){var q=el.getBoundingClientRect();if(!q.width)return;var cur=+el.dataset.sfLift||0,top=q.top+cur,bot=q.bottom+cur;
var v=(q.left<r&&q.right>l&&top<b+8&&bot>t-8)?Math.ceil(bot-t+8):0;if(top-v<60)v=0;if(v!==cur)todo.push([el,v])});
todo.forEach(function(x){x[0].dataset.sfLift=x[1];x[0].style.translate=x[1]?'0 '+(-x[1])+'px':''})}
function ask(){if(!tick){tick=true;requestAnimationFrame(run)}}
window.addEventListener('scroll',ask,{passive:true});window.addEventListener('resize',ask);window.addEventListener('load',ask);run()}
function go(){notes();lift()}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
/* end sf-design-20261103 */
